import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    title: String,
    text: String
  }

  share(event) {
    event.preventDefault()
    console.log("Share button clicked")

    const shareData = {
      title: this.titleValue || document.title,
      text: this.textValue || "",
      url: this.urlValue || window.location.href
    }

    console.log("Share data:", shareData)

    if (navigator.share && navigator.canShare(shareData)) {
      console.log("Using Native Share API")
      navigator.share(shareData)
        .then(() => console.log('Successful share'))
        .catch((error) => {
          console.log('Error sharing', error)
          // If user cancelled or failed, fallback to copy
          const combinedText = `${shareData.text} ${shareData.url}`
          this.copyToClipboard(combinedText)
        })
    } else {
      console.log("Native Share API not available, copying to clipboard")
      const combinedText = `${shareData.text} ${shareData.url}`
      this.copyToClipboard(combinedText)
    }
  }

  async copyToClipboard(url) {
    try {
      await navigator.clipboard.writeText(url)
      this.showToast("Link copied to clipboard!")
    } catch (err) {
      console.error('Failed to copy: ', err)
      // Fallback for older browsers
      const textArea = document.createElement("textarea")
      textArea.value = url
      document.body.appendChild(textArea)
      textArea.select()
      try {
        document.execCommand('copy')
        this.showToast("Link copied to clipboard!")
      } catch (err) {
        console.error('Fallback copy failed', err)
      }
      document.body.removeChild(textArea)
    }
  }

  copy(event) {
    event.preventDefault()
    this.copyToClipboard(this.urlValue || window.location.href)
  }

  showToast(message) {
    // We'll use our existing flash controller if possible, 
    // or create a simple temporary one for this action.
    const event = new CustomEvent("flash:show", {
      detail: { 
        message: message, 
        type: "notice" 
      }
    })
    window.dispatchEvent(event)
  }
}
